/* Millo Gang · Bolsos (tema de Shopify, 12-oct-2026): bolsos en anillo con GSAP. Copia del script de collections/bags de la web de trabajo; único cambio, el #hash tras el formulario «Avísame». */
(function () {
  var S = document.querySelector('.rh');
  if (!S || !window.gsap) return;
  var g = window.gsap;
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var D = RM ? 0.01 : 1;
  var TAU = Math.PI * 2;
  var stage = S.querySelector('.rh-stage');
  var slots = [].slice.call(S.querySelectorAll('.rh-slot'));
  var bags = [].slice.call(S.querySelectorAll('.rh-bag'));
  var panels = [].slice.call(S.querySelectorAll('.rh-p'));
  var dots = [].slice.call(S.querySelectorAll('.rh-dot'));
  var sides = [].slice.call(S.querySelectorAll('.rh-ths'));
  var wordBox = S.querySelector('.rh-word');
  var words = S.dataset.words.split('|');
  var intro = S.querySelector('.rh-intro');
  var back = S.querySelector('.rh-back');
  var cNum = S.querySelector('.rh-c'), cTxt = S.querySelector('.rh-ct');
  var nowN = S.querySelector('.rh-bn'), nowT = S.querySelector('.rh-bt');
  var NB = bags.length, NS = slots.length, STEP = TAU / NS;
  var names = panels.map(function (p) { var h = p.querySelector('.rh-name').cloneNode(true), n = h.querySelector('.rh-pn'); if (n) n.remove(); return h.textContent.trim().replace(/\.$/, ''); });

  // Estado del carrusel
  var R = { rot: 0, spread: 1, a: 1 };
  var slotA = slots.map(function () { return { a: 1 }; });
  var speed = RM ? 0 : -TAU / 22;         // una vuelta cada 22 s
  var vel = 0, auto = 1, hover = false, dragging = false, moved = 0;
  var sel = -1, front = -1, photo = [], busy = false;
  for (var k = 0; k < NB; k++) photo.push(-1);

  S.classList.add('rh-js');
  function setTop() { var hd = document.querySelector('header'); if (hd) S.style.setProperty('--rh-hd', Math.round(hd.getBoundingClientRect().bottom) + 'px'); }
  function mob() { return window.innerWidth <= 768; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function radius() { var W = stage.clientWidth, H = LM.v || stage.clientHeight; return mob() ? .4 * W : Math.min(.26 * W, .5 * H * 1.75); }

  // Geometria del anillo
  // Alto libre para el anillo: en escritorio, hasta el bloque de texto de abajo
  var LM = { v: 0 };
  function measure() {
    var ir = intro.getBoundingClientRect(), sr = stage.getBoundingClientRect();
    // con el nombre arriba (escritorio), los bolsos usan toda la altura; si estuviera abajo, el hueco que queda encima
    var t = mob() ? stage.clientHeight : (ir.top - sr.top < sr.height / 2 ? stage.clientHeight - 24 : Math.max(260, ir.top - sr.top + 6));
    if (!LM.v) LM.v = t; else g.to(LM, { v: t, duration: .7 * D, ease: 'power3.inOut', overwrite: true });
  }
  function ring(k) {
    var W = stage.clientWidth, m = mob(), H = LM.v || stage.clientHeight;
    var U = Math.min(W, H * 1.75);
    var a = R.rot + k * STEP, c = Math.cos(a), s = Math.sin(a), d = (c + 1) / 2;
    var fw = m ? .74 * W : Math.min(.54 * U, H * 1.3);
    return {
      x: W / 2 + s * radius() * R.spread - 300, y: (m ? .64 : .58) * H - (1 - d) * H * (m ? .52 : .045) - 250,
      scale: fw / 600 * (.66 + .34 * Math.pow(d, 1.2)) * (+slots[k].dataset.f || 1), z: Math.round(d * 100),
      o: R.a * slotA[k].a, d: d
    };
  }
  var T0 = performance.now();
  function render() {
    var best = -1, bd = -1, t = RM ? 0 : (performance.now() - T0) / 1000;
    slots.forEach(function (el, k) {
      var p = ring(k), ph = k * 2.1;
      // cada bolso flota con su ritmo: sube y baja, se mece y se balancea
      var fy = Math.sin(t * .9 + ph) * 12 + Math.sin(t * 2.3 + ph) * 3;
      var fx = Math.cos(t * .55 + ph) * 8;
      var fr = Math.sin(t * .7 + ph * 1.3) * 3.2 + Math.sin(t * 1.9 + ph) * .8;
      el.style.transform = 'translate3d(' + (p.x + fx) + 'px,' + (p.y + fy) + 'px,0) rotate(' + fr + 'deg) scale(' + p.scale + ')';
      el.style.zIndex = p.z;
      el.style.opacity = p.o;
      el.style.visibility = p.o < .01 ? 'hidden' : 'visible';
      if (p.d > bd) { bd = p.d; best = k; }
    });
    var fb = +slots[best].dataset.b;
    if (fb !== front) { front = fb; if (sel < 0) counter(); }
  }
  g.ticker.add(function (t, dt) {
    dt = Math.min(dt, 50) / 1000;
    if (sel < 0 && !dragging) {
      auto += ((hover ? 0 : 1) - auto) * Math.min(1, dt * 4);
      R.rot += speed * auto * dt + vel * dt;
      vel *= Math.pow(.04, dt);
    }
    if (R.a > 0) render();
  });

  // Arrastrar para girar
  var px = 0, lt = 0;
  stage.addEventListener('pointerdown', function (e) {
    if (sel >= 0 || e.button > 0) return;
    dragging = true; moved = 0; px = e.clientX; lt = performance.now(); vel = 0;
    g.killTweensOf(R, 'rot');
  });
  window.addEventListener('pointermove', function (e) {
    if (!dragging) return;
    var dx = e.clientX - px, now = performance.now(), Rx = radius();
    px = e.clientX; moved += Math.abs(dx);
    R.rot += dx / Rx;
    vel = (dx / Rx) / Math.max(.001, (now - lt) / 1000) * .5; lt = now;
  });
  window.addEventListener('pointerup', function () { dragging = false; });

  function spinTo(r) { vel = 0; g.to(R, { rot: r, duration: .9 * D, ease: 'power3.inOut', overwrite: 'auto' }); }
  function snapStep(d) { spinTo(Math.round(R.rot / STEP) * STEP - d * STEP); }
  function nearest(b) {
    var best = 0, bc = -2;
    slots.forEach(function (el, k) { if (+el.dataset.b === b) { var c = Math.cos(R.rot + k * STEP); if (c > bc) { bc = c; best = k; } } });
    return best;
  }
  function bringFront(b) {
    var cur = R.rot + nearest(b) * STEP, tgt = Math.round(cur / TAU) * TAU;
    spinTo(R.rot + (tgt - cur));
  }

  // Bolso solo
  function soloL() {
    var W = stage.clientWidth, H = stage.clientHeight, U = Math.min(W, H * 1.5);
    if (mob()) return { x: .5 * W - 300, y: .5 * H - 250, scale: Math.min(.86 * W, 1.05 * H) / 600 };
    var left = S.querySelector('.rh-side').offsetWidth + 40, area = W - S.querySelector('.rh-panel').offsetWidth - 40 - left;
    return { x: left + area * .5 - 300, y: .52 * H - 250, scale: Math.min(.56 * U, area * .9) / 600 };
  }
  function layers(i) { return [].slice.call(bags[i].querySelectorAll('.rh-ph')); }
  function showPhoto(i, j, instant, dir) {
    var Ls = layers(i), t = Ls[j]; if (!t) return;
    Ls.forEach(function (l) { if (!l.getAttribute('src')) l.src = l.dataset.src; });
    var cur = photo[i] >= 0 ? Ls[photo[i]] : null;
    if (cur === t) return;
    photo[i] = j;
    var from = cur ? Ls.indexOf(cur) : -1;
    if (instant || !cur) { g.killTweensOf(Ls); Ls.forEach(function (l) { g.set(l, { autoAlpha: l === t ? 1 : 0, yPercent: 0 }); }); }
    else {
      // Cambio de foto como una tira vertical: la actual sube y sale, la nueva entra desde abajo (sin fundidos)
      dir = dir || (j > from ? 1 : -1);
      g.killTweensOf(Ls);
      Ls.forEach(function (l) { if (l !== t && l !== cur) g.set(l, { autoAlpha: 0, yPercent: 0 }); });
      g.set(t, { autoAlpha: 1, yPercent: dir * 100 });
      g.to(t, { yPercent: 0, duration: .85 * D, ease: 'expo.inOut' });
      g.to(cur, { yPercent: -dir * 100, duration: .85 * D, ease: 'expo.inOut', onComplete: function () { g.set(cur, { autoAlpha: 0, yPercent: 0 }); } });
    }
    var p = sides[i];
    p.querySelectorAll('.rh-th').forEach(function (b, k) { b.classList.toggle('on', k === j); b.setAttribute('aria-pressed', k === j ? 'true' : 'false'); });
  }
  bags.forEach(function (b) { g.set(b.querySelector('.rh-g'), { autoAlpha: 0 }); g.set(b, { autoAlpha: 0 }); });
  if (!RM) bags.forEach(function (b, i) {
    var fl = b.querySelector('.rh-fl');
    g.to(fl, { y: -10, duration: 2.4 + i * .3, ease: 'sine.inOut', yoyo: true, repeat: -1 });
    g.to(fl, { rotation: 1.6, duration: 3.1 + i * .4, ease: 'sine.inOut', yoyo: true, repeat: -1, delay: -1.2 });
  });

  // Texto gigante
  function fit(el) {
    if (!el) return;
    el.style.fontSize = '100px';
    var w = el.scrollWidth, H = wordBox.clientHeight;
    el.style.fontSize = Math.min(100 * (wordBox.clientWidth * .96) / w, H * .62) + 'px';
  }
  function chars(el, t) { el.innerHTML = t.split('').map(function (c) { return '<i>' + (c === ' ' ? '&nbsp;' : c) + '</i>'; }).join(''); }
  var wEl = wordBox ? wordBox.querySelector('.rh-w') : null;
  if (wEl) { chars(wEl, words[0]); fit(wEl); }
  function setWord(t) {
    if (!wEl) return;
    var old = wEl, nw = document.createElement('span');
    nw.className = 'rh-w'; nw.style.position = 'absolute';
    chars(nw, t); wordBox.appendChild(nw); fit(nw);
    g.to(old.children, { yPercent: -60, autoAlpha: 0, duration: .45 * D, stagger: .025 * D, ease: 'power2.in', onComplete: function () { old.remove(); nw.style.position = ''; } });
    g.from(nw.children, { yPercent: 60, autoAlpha: 0, duration: .7 * D, stagger: .035 * D, ease: 'power3.out', delay: .35 * D });
    wEl = nw;
  }

  // El nombre siempre en una linea: si no cabe, baja el tamano
  var big = S.querySelector('.rh-big');
  function fitBig() {
    big.style.fontSize = '';
    var avail = intro.clientWidth - parseFloat(getComputedStyle(intro).paddingLeft) * 2;
    var w = big.scrollWidth;
    if (w > avail) big.style.fontSize = (parseFloat(getComputedStyle(big).fontSize) * avail / w) + 'px';
  }
  // Nombre gigante del bolso de delante: las letras caen y entran
  var bigI = 0;
  function bigName(i) {
    if (i === bigI && nowT.dataset.ok) return;
    bigI = i; nowT.dataset.ok = 1;
    var t = names[i].toUpperCase() + '.';
    g.killTweensOf(nowT.querySelectorAll('i'));
    nowT.innerHTML = t.split(' ').map(function (w) { return '<span class="rh-bw">' + w.split('').map(function (c) { return '<i>' + c + '</i>'; }).join('') + '</span>'; }).join('');
    nowN.textContent = pad(i + 1);
    fitBig();
    g.fromTo(nowT.querySelectorAll('i'), { yPercent: 105 }, { yPercent: 0, duration: .75 * D, stagger: .028 * D, ease: 'expo.out' });
    measure();
    g.fromTo(nowN, { yPercent: -105 }, { yPercent: 0, duration: .75 * D, ease: 'expo.out' });
  }
  function counter() {
    var i = sel >= 0 ? sel : front;
    if (i < 0) return;
    if (cNum.textContent !== pad(i + 1)) g.fromTo(cNum, { yPercent: 40, autoAlpha: 0 }, { yPercent: 0, autoAlpha: 1, duration: .5 * D, ease: 'power3.out' });
    cNum.textContent = pad(i + 1); cTxt.textContent = '/ ' + pad(NB);
    bigName(i);
    dots.forEach(function (d, k) { d.classList.toggle('on', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
  }

  // Nombre del panel: que ninguna palabra se salga del ancho
  function fitName(p) {
    var h = p.querySelector('.rh-name'); h.style.fontSize = '';
    var w = h.scrollWidth, cw = h.clientWidth;
    if (w > cw) h.style.fontSize = (parseFloat(getComputedStyle(h).fontSize) * cw / w * .98) + 'px';
  }
  function showPanel(i, prev) {
    var go = function () {
      panels.forEach(function (p, k) { p.hidden = k !== i; });
      sides.forEach(function (p, k) { p.hidden = k !== i; });
      if (i < 0) return;
      panels[i].scrollTop = 0;
      fitName(panels[i]);
      g.fromTo(sides[i].children, { x: -14, autoAlpha: 0 }, { x: 0, autoAlpha: 1, duration: .5 * D, stagger: .05 * D, ease: 'power3.out', delay: .45 * D });
      g.fromTo(panels[i].children, { y: 18, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: .6 * D, stagger: .05 * D, ease: 'power3.out', delay: .35 * D });
    };
    if (prev >= 0) g.to(sides[prev].children, { autoAlpha: 0, duration: .25 * D });
    if (prev >= 0) g.to(panels[prev].children, { y: -10, autoAlpha: 0, duration: .3 * D, stagger: .02 * D, ease: 'power2.in', onComplete: go });
    else go();
  }

  function lock(ms) { busy = true; setTimeout(function () { busy = false; }, ms * D); }

  // Abrir desde el anillo: el bolso pulsado se queda, los demas se apartan
  function openFromSlot(k) {
    if (busy || sel >= 0) return; lock(900);
    var i = +slots[k].dataset.b, p = ring(k), b = bags[i];
    sel = i;
    vel = 0; g.killTweensOf(R, 'rot');
    var n = slots[k].querySelector('img').getAttribute('src').match(/mg-rh-(.+?)\.webp/)[1];
    // siempre entra por la primera foto (la de frente)
    showPhoto(i, 0, true);
    g.set(b, { x: p.x, y: p.y, scale: p.scale, rotation: 0, autoAlpha: 1, zIndex: 200 });
    slotA[k].a = 0;
    g.to(R, { spread: 2.1, a: 0, duration: .9 * D, ease: 'expo.inOut' });
    S.classList.add("is-solo"); // antes de medir: en móvil el escenario del bolso abierto es más bajo
    var L = soloL();
    g.to(b, { x: L.x, y: L.y, scale: L.scale, duration: 1.05 * D, ease: 'expo.inOut' });
    enterSolo(i, -1);
  }
  function enterSolo(i, prev) {
    S.classList.add('is-solo');
    setWord(words[i + 1]);
    counter();
    showPanel(i, prev);
    if (prev < 0) {
      g.to(intro, { autoAlpha: 0, y: 10, duration: .35 * D });
      back.hidden = false; g.fromTo(back, { autoAlpha: 0, x: -10 }, { autoAlpha: 1, x: 0, duration: .5 * D, delay: .5 * D });
      if (mob()) S.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' });
    }
    history.replaceState(null, '', '#' + panels[i].id);
  }
  // Cambiar de bolso estando abierto
  function switchTo(i, dir) {
    if (busy || i === sel) return; lock(800);
    var prev = sel, W = stage.clientWidth, ob = bags[prev], nb = bags[i], L = soloL();
    sel = i;
    g.to(ob, { x: '-=' + dir * W * .9, rotation: -dir * 10, autoAlpha: 0, duration: .9 * D, ease: 'expo.inOut' });
    showPhoto(i, 0, true);
    g.fromTo(nb, { x: L.x + dir * W * .9, y: L.y, scale: L.scale * .8, rotation: dir * 10, autoAlpha: 0, zIndex: 200 },
      { x: L.x, scale: L.scale, rotation: 0, autoAlpha: 1, duration: 1 * D, ease: 'expo.inOut', delay: .08 * D });
    enterSolo(i, prev);
  }
  function close() {
    if (sel < 0 || busy) return; lock(900);
    var i = sel, b = bags[i], k = nearest(i);
    slotA.forEach(function (o, s) { o.a = s === k ? 0 : 1; });
    sel = -1;
    var keep = R.spread; R.spread = 1; var p = ring(k); R.spread = keep;
    g.to(R, { spread: 1, a: 1, duration: .95 * D, ease: 'expo.inOut' });
    g.to(b, { x: p.x, y: p.y, scale: p.scale, rotation: 0, duration: .95 * D, ease: 'expo.inOut', onComplete: function () {
      slotA[k].a = 1; g.set(b, { autoAlpha: 0 });
      photo[i] = -1; layers(i).forEach(function (l) { g.set(l, { autoAlpha: 0 }); });
    } });
    bags.forEach(function (o, s) { if (s !== i) { g.set(o, { autoAlpha: 0 }); } });
    bags.forEach(function (o, s) { if (s !== i && photo[s] >= 0) { layers(s).forEach(function (l) { g.set(l, { autoAlpha: 0 }); }); photo[s] = -1; } });
    S.classList.remove('is-solo');
    setWord(words[0]);
    counter();
    sides.forEach(function (sd) { if (!sd.hidden) g.to(sd.children, { autoAlpha: 0, duration: .3 * D, onComplete: function () { sd.hidden = true; } }); });
    panels.forEach(function (pn) { if (!pn.hidden) g.to(pn.children, { autoAlpha: 0, duration: .3 * D, onComplete: function () { pn.hidden = true; } }); });
    g.to(back, { autoAlpha: 0, duration: .3 * D, onComplete: function () { back.hidden = true; } });
    g.fromTo(intro, { autoAlpha: 0, y: 10 }, { autoAlpha: 1, y: 0, duration: .6 * D, delay: .6 * D });
    history.replaceState(null, '', location.pathname + location.search);
    slots[k].focus({ preventScroll: true });
  }
  function step(d) {
    if (sel < 0) snapStep(d);
    else switchTo((sel + d + NB) % NB, d);
  }

  slots.forEach(function (el, k) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      if (moved > 6) return;
      openFromSlot(k);
    });
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
  });
  bags.forEach(function (b, i) {
    b.addEventListener('click', function (e) { e.preventDefault(); if (sel === i) showPhoto(i, (photo[i] + 1) % layers(i).length); });
  });
  dots.forEach(function (d, i) {
    d.addEventListener('click', function () { if (sel < 0) bringFront(i); else switchTo(i, i > sel ? 1 : -1); });
  });
  S.querySelector('.rh-next').addEventListener('click', function () { step(1); });
  S.querySelector('.rh-prev').addEventListener('click', function () { step(-1); });
  back.addEventListener('click', close);
  sides.forEach(function (p, i) {
    p.querySelectorAll('.rh-th').forEach(function (t, j) { t.addEventListener('click', function () { showPhoto(i, j); }); });
  });
  document.addEventListener('keydown', function (e) {
    var r = S.getBoundingClientRect();
    if (r.bottom < 0 || r.top > window.innerHeight) return;
    var tg = e.target.tagName;
    if (tg === 'INPUT' || tg === 'TEXTAREA') return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') step(1);
    else if (e.key === 'ArrowLeft') step(-1);
  });
  // Rueda o trackpad sobre la foto: abajo = siguiente foto, arriba = la anterior
  var wLock = 0, wAcc = 0, wLast = 0, wGest = 0, wChanged = -1;
  S.addEventListener('wheel', function (e) {
    if (sel < 0 || mob()) return;
    // dentro del panel, solo si de verdad tiene scroll propio
    var pn = e.target.closest && e.target.closest('.rh-p');
    if (pn && pn.scrollHeight > pn.clientHeight + 2) return;
    var now0 = performance.now();
    if (now0 - wLast > 280) wGest = now0;                         // gesto nuevo tras una pausa
    wLast = now0;
    if (pn) return;
    var n = layers(sel).length, j = photo[sel], d = e.deltaY > 0 ? 1 : -1;
    if ((d > 0 && j >= n - 1) || (d < 0 && j <= 0)) {
      // en los extremos: la inercia del mismo gesto no mueve la pagina; un gesto nuevo, si
      if (wChanged >= wGest || now0 < wLock) e.preventDefault();
      wAcc = 0; return;
    }
    e.preventDefault();
    if (e.target.closest && e.target.closest('.rh-side')) return;
    var now = performance.now();
    if (now < wLock) return;
    wAcc += e.deltaY;
    if (Math.abs(wAcc) < 30) return;
    wAcc = 0; wLock = now + 900; wChanged = now;
    showPhoto(sel, j + d, false, d);
  }, { passive: false });
  var tx = null;
  stage.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
  stage.addEventListener('touchend', function (e) {
    if (tx === null || sel < 0) return;
    var dx = e.changedTouches[0].clientX - tx; tx = null;
    if (Math.abs(dx) > 50) step(dx < 0 ? 1 : -1);
  }, { passive: true });

  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () { setTop(); fitBig(); measure(); fit(wEl); if (sel >= 0) g.set(bags[sel], soloL()); }, 120);
  });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fit(wEl); fitBig(); measure(); });

  // Arranque
  setTop(); measure();
  var h = location.hash.slice(1).replace(/-avisame$/, ''), start = -1;  /* tema: tras apuntarse, el formulario vuelve con #<bolso>-avisame */
  panels.forEach(function (p, i) { if (p.id === h) start = i; });
  if (start >= 0) {
    var k0 = slots.map(function (el) { return +el.dataset.b; }).indexOf(start);
    R.rot = -k0 * STEP; render();
    openFromSlot(k0);
  } else {
    render(); counter();
    g.from(R, { spread: .2, a: 0, rot: R.rot + 1.2, duration: 1.6 * D, ease: 'expo.out' });
    if (wEl) g.from(wEl.children, { yPercent: 60, autoAlpha: 0, duration: .9 * D, stagger: .03 * D, ease: 'power3.out', delay: .1 });
    bigName(front < 0 ? 0 : front);
    g.from(intro.children, { y: 20, autoAlpha: 0, duration: .8 * D, stagger: .08 * D, ease: 'power3.out', delay: .35 * D });
  }
})();

